// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/insa-pivot/style/pivotviewer.css
// module id = 565
// module chunks = 3